<!-- Manage users screen -->
<ng-container *ngIf="userStub">
    <h3>
        <!-- Delete user -->
        <button mat-button color="warn"  class="float-right" [disabled]="userStub.user.id == fourD.activeUser.id" 
    (click)="removeUser()" id="delete-user" [matTooltip]=" 'GENERIC.DELETE' | translate "><fa-icon icon="trash"></fa-icon></button>
        <img vlink="image.png" [model]="userStub.user" class="icon mr-3" />{{ userStub.user.name }}
    </h3>

    <!-- Invite user -->
    <mat-slide-toggle *ngIf="!userStub.isInvite" class="ml-5" [disabled]="userStub.user.id == fourD.activeUser.id" [(ngModel)]="userStub.isAdmin" (change)="setAdmin()">{{ 'GENERIC.ACL.ACCOUNT_ADMIN' | translate }}</mat-slide-toggle>

    <!-- User list -->
    <div *ngIf="userStub.isAdmin">
        <table class="fdm-sidebar-table-list">
            <tr>
                <td colspan="3" class="text-center p-4">{{ 'USER_ADMIN.PRIVILEGES' | translate }}</td>
            </tr>
        </table>
    </div>
    <ng-container *ngIf="!userStub.isAdmin">
        <div *ngIf="projects | async as projList">

            <div *ngIf="showAddProjects" id="addUserProjects" class="fdm-dialog fdm-fade">
                <div class="fdm-overlay-full" (click)="closeAddProjects()"></div>
                <h3>
                    {{ 'GENERIC.ACL.ADD_PROJECT' | translate }}
                    <fa-icon icon="times" class="fdm-link float-right" style="font-size:22px;margin-right:5px;" (click)="closeAddProjects()"></fa-icon>
                </h3>
                <div class="content">
                    <table class="fdm-sidebar-table-list">
                        <tr *ngFor="let p of fourD.projects">
                            <td *ngIf="!hasProject(projList,p)" class="fdm-linked focus-hover" (click)="addProject(p);closeAddProjects();">
                                <fa-icon [icon]="['far','square']" style="margin-right:12px;"></fa-icon>
                                {{ p.name }} <span style="color:#bbb">({{ p.id }})</span>
                            </td>
                            <td *ngIf="hasProject(projList,p)" class="disabled">
                                <fa-icon [icon]="['far','check-square']" style="margin-right:12px;color:rgb(204, 224, 204);"></fa-icon>
                                {{ p.name }} <span style="color:#bbb">({{ p.id }})</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        
            <table class="fdm-sidebar-table-list">
                <tr>
                
                    <!-- Projects column -->
                    <th>{{ 'USER_ADMIN.PROJECT' | translate }}</th>
        
                     <!-- Roles column -->
                    <th>{{ 'USER_ADMIN.ROLE' | translate }}</th>
        
                     <!-- Actions column -->
                    <th>{{ 'USER_ADMIN.ACTIONS' | translate }}</th>
                </tr>

                <!-- Project name -->
                <ng-container *ngIf="projList.length">
                    <tr *ngFor="let cur of projList">
                        <td [ngClass]="{'text-danger':!cur.valid}" class="p-3">{{ cur.project.name }}</td>
                        <td>
        
                            <!-- Role selection -->
                            <mat-form-field>
                                <mat-label></mat-label>
                                <mat-select #me [formControl]="cur.role" multiple (selectionChange)="addUserRole(cur)" id="add-role">
                                  <mat-option *ngFor="let r of roles" [value]="r.uid">{{r.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>

                        <!-- Remove user from project -->
                        <td class="p-3">
                            <fa-icon icon="trash" class="text-danger" (click)="removeUserFromProj(cur)"  id="remove-user"></fa-icon>
                        </td>
        
                    </tr>
                </ng-container>

                <!-- No current projects for user -->
                <tr *ngIf="!projList.length">
                    <td colspan="3" class="text-center p-4">{{ 'USER_ADMIN.NO_PROJECTS' | translate }}</td>
                </tr>
                <tr>
                    <!-- Add projects button -->
                    <td colspan="3" class="text-left p-4">
                        <button mat-raised-button color="accent" id="add-projects" (click)="addProjects()">{{ 'GENERIC.ACL.ADD_PROJECT' | translate }}</button>
                    </td>
                </tr>
                <!-- <tr>
                    <td colspan="2">
                    
                        <div qmap-question
                            [qMap]="{type:'object',id:'addProj',obj_type:'Project',title:('SETTINGS.ADD_PROJECT' | translate),filter:{op:'=',col:'account',val:this.fourD.activeTeam.id}}" 
                            [model]="this"
                        ></div>
        
                        <mat-form-field>
                            <mat-label></mat-label>
                            <mat-select #meagain [formControl]="projects" multiple (selectionChange)="addProjects(tmp)" id="add-projects">
                              <mat-option *ngFor="let r of fourD.projects" [value]="r.uid">{{r.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
        
                    </td>
                
                    <td class="p-3">
                        <button mat-raised-button [disabled]="!addProj" (click)="addProject()">{{ 'GENERIC.ACL.ADD_PROJECT' | translate }}</button>
                    </td>
                </tr> -->
        
            </table>
        </div>
    </ng-container>
</ng-container>